import { litters_current } from "./litters_current";
import { litters_Previous } from "./litters_previous";

export const litters = [
        {title:"Current", url:"litters/current", submenu:litters_current},
        {title:"Previous", url:"litters/previous", submenu:litters_Previous}
    ];